import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import * as Sentry from "@sentry/angular";
import {environment} from './environments/environment';

Sentry.init({
  dsn: environment.sentry.DSN,
  integrations: [
    // Registers and configures the Tracing integration,
    // which automatically instruments your application to monitor its
    // performance, including custom Angular routing instrumentation
    Sentry.browserTracingIntegration(),
  ],
  environment: environment.sentry.environment,
});

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
